import { useEffect } from 'react'

import { calibrateServerClock } from '../lib/serverClock'

const RESYNC_INTERVAL_MS = 5 * 60 * 1000
const MAX_INITIAL_RETRY_MS = 30_000

export function useServerClockCalibration(): void {
  useEffect(() => {
    let stopped = false
    let syncing = false
    let retryMs = 1000
    let retryTimer: number | null = null
    const sync = async () => {
      if (stopped || syncing) return
      syncing = true
      if (retryTimer !== null) {
        window.clearTimeout(retryTimer)
        retryTimer = null
      }
      try {
        const estimate = await calibrateServerClock()
        if (stopped || estimate) {
          retryMs = 1000
          return
        }
        retryTimer = window.setTimeout(() => void sync(), retryMs)
        retryMs = Math.min(MAX_INITIAL_RETRY_MS, retryMs * 2)
      } finally {
        syncing = false
      }
    }

    void sync()
    const interval = window.setInterval(() => void sync(), RESYNC_INTERVAL_MS)
    const onVisibility = () => {
      if (document.visibilityState === 'visible') void sync()
    }
    document.addEventListener('visibilitychange', onVisibility)

    return () => {
      stopped = true
      window.clearInterval(interval)
      if (retryTimer !== null) window.clearTimeout(retryTimer)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [])
}
